var CommonTableComponent_1;
import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./common-table.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./common-table.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output, ViewChildren } from "@angular/core";
import { SubscriberComponent } from "../subscriber/subscriber.component";
import { CommonTableSortHeaderDirective } from "../../directives/common-table-sort-header.directive";
import { compare } from "../../models/sort.model";
// import {IRecipient} from "../../../../../afla-v2/src/app/shared/models/application/generic/recipient.models";
import { SharedConstants } from "../../constants/shared-constants";
import { ActivatedRoute, Router } from "@angular/router";
import moment from "moment";
import SearchUtils from "../../utils/search-utils";
import _ from "underscore";
let elId = 0;
export let CommonTableComponent = class CommonTableComponent extends SubscriberComponent {
    static { CommonTableComponent_1 = this; }
    changeDetectorRef;
    route;
    router;
    headers;
    tableItems = [];
    columnToItemPropertyMap;
    tdTemplate;
    tdTemplate2;
    thTemplate;
    rowActions = false;
    checkboxColumn = false;
    showRadioButtonColumn = false;
    allowSingleSelect = false;
    disableRowSelect = true;
    nextID = elId++;
    pageName = "";
    defaultSort;
    showRecipientTypeColumn = false;
    preSelected = SharedConstants.FILTER_BY_DEFAULT;
    parentComponent = "";
    allowExport = false;
    isApplicationSearchTable = false;
    tableItemClicked = new EventEmitter();
    tableItemsChecked = new EventEmitter();
    // @Output() recipientRadioButtonClicked: EventEmitter<IRecipient> = new EventEmitter<IRecipient>();
    tableColumns = [];
    visibleTableItems = [];
    searchTerm = "";
    // @ts-ignore
    selectedColumn;
    // @ts-ignore
    focusedElement;
    selectedRows = [];
    isSelected = false;
    filterByOptions = [];
    preSelectedFilterText = "";
    preSelectedFilterColumn = SharedConstants.FILTER_BY_DEFAULT;
    noItemsMessage = SharedConstants.NO_ITEMS_AVAILABLE_MESSAGE;
    noFilterResults = SharedConstants.NO_FILTER_RESULTS;
    exportFilenameLabel = SharedConstants.ENTER_FILENAME_LABEL;
    applyTableWidthClass = false;
    constructor(changeDetectorRef, route, router) {
        super();
        this.changeDetectorRef = changeDetectorRef;
        this.route = route;
        this.router = router;
    }
    static checkIfObject(test) {
        return typeof test === "object";
    }
    static checkIfDate(test) {
        return moment(test, SharedConstants.SYSTEM_DATE_FORMAT_DEFAULT, true).isValid();
    }
    checkIfNumber(maybeNumber) {
        const checkNumber = Number(maybeNumber);
        return !isNaN(checkNumber);
    }
    getObjectId(row) {
        // @ts-ignore
        return row.hasOwnProperty("id") ? row.id.toString() : "";
    }
    ngAfterViewInit() {
        this.headers.forEach((header) => {
            if (header.sortable === this.defaultSort) {
                header.direction = "asc";
            }
        });
        this.expandTableHorizontally();
    }
    ngOnChanges(changes) {
        this.isSelected = false;
        this.selectedRows = [];
        this.tableItemsChecked.emit(this.selectedRows);
        this.tableItems = changes.tableItems ? changes.tableItems.currentValue : this.tableItems;
        this.setInitialVisibleTableItems();
        if (this.tableItems) {
            this.filterTable({ text: this.searchTerm, column: this.selectedColumn });
        }
        if (changes.hasOwnProperty("columnToItemPropertyMap") && !this.applyTableWidthClass)
            this.expandTableHorizontally();
    }
    ngOnInit() {
        this.checkIfColumnMappingExists();
        this.listenForQueryParamChanges();
        this.initialize();
    }
    ngOnDestroy() {
        super.ngOnDestroy();
    }
    radioButtonAction(row) {
        this.selectedRows = [];
        this.selectedRows.push(row);
        this.tableItemsChecked.emit(this.selectedRows);
        this.tableItems.map(tableItem => {
            // @ts-ignore
            if (row.id === tableItem.id) {
                // @ts-ignore
                tableItem.selected = true;
            }
            else {
                // @ts-ignore
                tableItem.selected = false;
            }
        });
    }
    checkBoxAction(row, event) {
        if (!this.disableRowSelect || this.allowSingleSelect || this.checkboxColumn) {
            const index = this.selectedRows.indexOf(row, 0);
            if (this.tableItems && this.allowSingleSelect) {
                this.tableItems.map(tableItem => {
                    // @ts-ignore
                    if (row.id === tableItem.id) {
                        // @ts-ignore
                        tableItem.selected = !row.selected;
                    }
                    else {
                        // @ts-ignore
                        tableItem.selected = false;
                    }
                });
                this.selectedRows = [];
            }
            if (event === false) {
                this.selectedRows.splice(index, 1);
                // set the table item to false
                if (this.tableItems) {
                    this.tableItems.map(tableItem => {
                        // @ts-ignore
                        if (row.id === tableItem.id) {
                            // @ts-ignore
                            tableItem.selected = false;
                        }
                    });
                }
                const checkAllBox = document.getElementById("tableCheckAll_" + this.nextID);
                // @ts-ignore
                if (checkAllBox?.checked) {
                    // @ts-ignore
                    checkAllBox.checked = false;
                }
            }
            else {
                // @ts-ignore
                row.selected = true;
                this.selectedRows.push(row);
            }
            this.tableItemsChecked.emit(this.selectedRows);
        }
    }
    checkedAll(event) {
        if (event === true) {
            this.isSelected = true;
            this.selectedRows = this.tableItems.slice(0);
            for (const selectedRow of this.tableItems) {
                // @ts-ignore
                selectedRow.selected = true;
            }
            this.tableItemsChecked.emit(this.selectedRows);
        }
        else {
            this.isSelected = false;
            this.selectedRows = [];
            for (const selectedRow of this.tableItems) {
                // @ts-ignore
                selectedRow.selected = false;
            }
            this.tableItemsChecked.emit(this.selectedRows);
        }
    }
    executeClickAction(row, column, $event) {
        // @ts-ignore
        this.checkBoxAction(row, !row.selected);
        this.tableItemClicked.emit(row);
    }
    getElementValue(element, column) {
        const propertyValue = this.getTableItemValue(element, column);
        if (propertyValue === undefined || propertyValue === null) {
            return "";
        }
        if (CommonTableComponent_1.checkIfObject(propertyValue)) {
            throw Error(SharedConstants.INVALID_TABLE_VALUE_ERROR);
        }
        return propertyValue;
    }
    filterTable(filter) {
        this.setQueryParams(filter);
        this.searchTerm = filter.text;
        this.selectedColumn = filter.column;
        if (!filter || !filter.text) {
            this.setInitialVisibleTableItems();
            this.changeDetectorRef.markForCheck();
            return;
        }
        if (filter.column === SharedConstants.FILTER_BY_DEFAULT || filter.column === undefined) {
            this.setVisibleTableItems(this.filterAllTableItems(filter.text));
        }
        else {
            this.setVisibleTableItems(this.filterTableItemsByColumn(filter));
        }
        this.changeDetectorRef.markForCheck();
    }
    onSort({ column, direction }) {
        this.setSortableHeaders(column);
        // @ts-ignore
        if (direction === "" || column === "") {
            this.visibleTableItems = this.tableItems;
        }
        else {
            this.visibleTableItems = this.sortTableItems(this.tableItems, column, direction);
        }
    }
    getTableDate() {
        return this.tableItems;
    }
    resetTableColumns() {
        if (!this.tableItems) {
            this.tableItems = new Array();
        }
        if (this.columnToItemPropertyMap) {
            this.tableColumns = Array.from(this.columnToItemPropertyMap.keys());
            this.initializeFilterOptions();
        }
    }
    initialize() {
        this.resetTableColumns();
        this.visibleTableItems = new Array();
        this.setInitialVisibleTableItems();
        if (!this.defaultSort) {
            this.defaultSort = { column: this.tableColumns[0], direction: "asc" };
        }
    }
    setInitialVisibleTableItems() {
        if (this.tableItems && this.tableItems.length > 0) {
            this.visibleTableItems = this.tableItems.slice(0);
            this.sortByDefault();
        }
        if (this.tableItems && this.tableItems.length === 0) {
            this.visibleTableItems = new Array();
        }
        this.changeDetectorRef.markForCheck();
    }
    filterAllTableItems(text) {
        // we only want to search the displayed columns - not all columns in tableItems
        return SearchUtils.searchAllItemsProperties(this.tableItems, text, this.listOfVisibleColumns());
    }
    listOfVisibleColumns() {
        const list = [];
        this.tableColumns.forEach((column) => {
            // @ts-ignore
            const mappedColumn = this.columnToItemPropertyMap.get(column);
            // @ts-ignore
            if (mappedColumn)
                list.push(mappedColumn);
        });
        // @ts-ignore
        return list;
    }
    filterTableItemsByColumn(search) {
        // @ts-ignore
        const mappedColumn = this.columnToItemPropertyMap.get(search.column);
        // @ts-ignore
        return SearchUtils.searchAllItemsSingleProperty(this.tableItems, mappedColumn, search.text);
    }
    setVisibleTableItems(items) {
        this.visibleTableItems = items;
    }
    checkForExistingCheckedItems() {
        for (const tableItem of this.visibleTableItems) {
            if (this.selectedRows.includes(tableItem)) {
                // @ts-ignore
                if (tableItem.hasOwnProperty("id")) {
                    // @ts-ignore
                    const checkbox = document.getElementById(tableItem.id);
                    console.log(checkbox.checked);
                    checkbox.checked = true;
                }
            }
        }
        this.changeDetectorRef.markForCheck();
    }
    initializeFilterOptions() {
        this.filterByOptions = new Array();
        this.filterByOptions.push(SharedConstants.FILTER_BY_DEFAULT);
        this.filterByOptions.push(..._.values(this.tableColumns));
        this.changeDetectorRef.detectChanges();
    }
    setSortableHeaders(column) {
        this.headers.forEach(header => {
            if (header.sortable !== column) {
                header.direction = "";
            }
        });
    }
    getTableItemValue(element, column) {
        // @ts-ignore
        return element[this.columnToItemPropertyMap.get(column)];
    }
    sortByDefault() {
        if (this.defaultSort && this.tableItems && this.tableItems.length > 0) {
            this.visibleTableItems = this.sortTableItems(this.tableItems, this.defaultSort.column, this.defaultSort.direction);
        }
    }
    sortTableItems(tableItems, column, direction = "asc") {
        return [...tableItems].sort((a, b) => {
            // TODO Dylan remove this cast when you remove the link safe html
            // @ts-ignore
            const result = compare(this.getCorrectPrimitiveTypeForPropertyValue(this.getElementValue(a, column)), this.getCorrectPrimitiveTypeForPropertyValue(this.getElementValue(b, column)));
            return direction === "asc" ? result : -result;
        });
    }
    getCorrectPrimitiveTypeForPropertyValue(propertyValue) {
        if (!propertyValue) {
            return null;
        }
        if (this.checkIfNumber(propertyValue)) {
            return +propertyValue;
        }
        if (CommonTableComponent_1.checkIfDate(propertyValue)) {
            return propertyValue;
        }
        // @ts-ignore
        return propertyValue.toLocaleString()?.toLocaleLowerCase();
    }
    checkIfColumnMappingExists() {
        if (!this.columnToItemPropertyMap) {
            throw new Error(SharedConstants.TABLE_COLUMN_MAPPING_EXISTS_ERROR);
        }
    }
    listenForQueryParamChanges() {
        this.route.queryParams.subscribe((queryParams) => {
            if (this.visibleTableItems !== this.tableItems) {
                this.filterTable({ column: queryParams.column, text: queryParams.text });
                this.preSelectedFilterText = queryParams.text;
                this.preSelectedFilterColumn = queryParams.column;
            }
        });
    }
    setQueryParams(filter) {
        this.router.navigate([], {
            queryParams: {
                text: filter.text,
                column: filter.column
            },
            queryParamsHandling: "merge"
        });
    }
    expandTableHorizontally() {
        if (this.columnToItemPropertyMap?.size > 0 && this.isApplicationSearchTable) {
            this.applyTableWidthClass = true;
        }
        else {
            this.applyTableWidthClass = false;
        }
        this.changeDetectorRef.detectChanges();
    }
    static ctorParameters = () => [
        { type: ChangeDetectorRef },
        { type: ActivatedRoute },
        { type: Router }
    ];
    static propDecorators = {
        headers: [{ type: ViewChildren, args: [CommonTableSortHeaderDirective,] }],
        tableItems: [{ type: Input }],
        columnToItemPropertyMap: [{ type: Input }],
        tdTemplate: [{ type: Input }],
        tdTemplate2: [{ type: Input }],
        thTemplate: [{ type: Input }],
        rowActions: [{ type: Input }],
        checkboxColumn: [{ type: Input }],
        showRadioButtonColumn: [{ type: Input }],
        allowSingleSelect: [{ type: Input }],
        disableRowSelect: [{ type: Input }],
        nextID: [{ type: Input }],
        pageName: [{ type: Input }],
        defaultSort: [{ type: Input }],
        showRecipientTypeColumn: [{ type: Input }],
        preSelected: [{ type: Input }],
        parentComponent: [{ type: Input }],
        allowExport: [{ type: Input }],
        isApplicationSearchTable: [{ type: Input }],
        tableItemClicked: [{ type: Output }],
        tableItemsChecked: [{ type: Output }]
    };
};
CommonTableComponent = CommonTableComponent_1 = __decorate([
    Component({
        // tslint:disable-next-line:component-selector
        selector: "lib-common-table[tableItems][columnToItemPropertyMap]",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CommonTableComponent);
